import axios from "axios"
const newsUrl = `/public/site/${process.env.MIX_TEMPLATE_FOLDER}/dist/data/news.json`

export default {
  props: {
    year: {
      type: String,
      required: true,
      default: "all"
    },
    _page: {
      type: Number,
      required: true,
      default: 1
    },
    _totalpages: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data() {
    return {
      news: [],
      page: this._page,
      totalPages: this._totalpages,
      nextPage: this._page < this._totalpages ? (this._page + 1) : null,
      loading: false,
    }
  },
  methods: {
    getArticles() {
      if (this.page <= this.totalPages) {
        this.nextPage = this.page + 1;
        this.loading = true
        var href = window.location.href.split('?')[0];
        href += '?page=' + this.nextPage;
        href += '&ajax=1';
        axios
          .get(href)
          .then(response => {
            var paginated = response.data;

            this.news = this.news.concat(response.data.data);
            this.loading = false;
            if (paginated.current_page < paginated.last_page) {
              this.nextPage = paginated.current_page + 1;
              this.page = this.page + 1;

            } else {
              this.nextPage = null;
            }
            this.alterGETparam('page', paginated.current_page);
          });
      } else {
        this.nextPage = null;
      }
    },
    getUrlParameter(sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    },
    alterGETparam(key, value) {

      var url = window.location.href;
      var parser = document.createElement('a');
      parser.href = url;

      var newUrl = parser.protocol + '//' + parser.host + parser.pathname;
      // has parameters ?
      if (parser.search && parser.search.indexOf('?') !== -1) {
        // parameter already exists
        if (parser.search.indexOf(key + '=') !== -1) {
          // paramters to array
          var params = parser.search.replace('?', '');
          params = params.split('&');
          params.forEach(function (param, i) {
            if (param.indexOf(key + '=') !== -1) {
              if (value !== null) params[i] = key + '=' + value;
              else delete params[i];
            }
          });
          if (params.length > 0) newUrl += '?' + params.join('&');
        } else if (value !== null) newUrl += parser.search + '&' + key + '=' + value; // append new parameter
        else newUrl += parser.search; // skip the value (remove)
      } else if (value !== null) newUrl += '?' + key + '=' + value; // no parameters, create it

      newUrl += parser.hash;
      if (newUrl[newUrl.length - 1] == '&') {
        newUrl = newUrl.substring(0, newUrl.length - 1);
      }
      window.history.replaceState('', '', newUrl);

    }
  }
}